export const projectData = [
    {
        displayName: "DrinkSelector",
        tagline: "Try a new drink tonight!",
        imgSource: "./data/projectImages/DrinkSelector.png",
        link: "https://mrmicrowaveoven.github.io/DrinkSelector/",
        github: "https://github.com/MrMicrowaveOven/DrinkSelector",
    },
    {
        displayName: "Trapped Game",
        tagline: "A game for learning useful things",
        imgSource: "./data/projectImages/Trapped.gif",
        link: "http://mrmicrowaveoven.github.io/TrappedGame/",
        github: "https://github.com/mrmicrowaveoven/TrappedGame",
    },
    // {
    //     displayName: "Needle-X",
    //     tagline: "A Needle Exchange Resource",
    //     imgSource: "./data/projectImages/NeedleX.png",
    //     link: "https://needle-x.herokuapp.com",
    //     github: "https://github.com/MrMicrowaveOven/NeedleX",
    // },
    // {
    //     displayName: "Sudoku Hint",
    //     tagline: "Let me solve your Sudoku puzzle!",
    //     imgSource: "./data/projectImages/SudokuSolver.gif",
    //     link: "https://sudoku-hint.herokuapp.com/",
    //     github: "https://github.com/MrMicrowaveOven/sudoku-solver",
    // },
    // {
    //     displayName: "Psychic Marilyn",
    //     tagline: "Marilyn tells when to leave for Bart",
    //     imgSource: "./data/projectImages/PsychicMarilyn.png",
    //     link: "https://psychic-marilyn.herokuapp.com/",
    //     github: "https://github.com/MrMicrowaveOven/PsychicMarilyn",
    // },
    {
        displayName: "DrawCircle",
        tagline: "How to make a circle from a set of points",
        imgSource: "./data/projectImages/DrawCircle.gif",
        link: "https://mrmicrowaveoven.github.io/DrawCircle/",
        github: "https://github.com/MrMicrowaveOven/DrawCircle",
    },
    {
        displayName: "Bocce Scoreboard",
        tagline: "A bocce ball scoring android app",
        imgSource: "./data/projectImages/BocceScore.gif",
        mobile: true,
        link: "https://play.google.com/store/apps/details?id=com.betterscore&hl=en_US",
        github: "https://github.com/MrMicrowaveOven/bocce-score",
    },
    {
        displayName: "Chill Pill",
        tagline: "A pill tracker android app",
        imgSource: "./data/projectImages/ChillPill.gif",
        mobile: true,
        link: "https://play.google.com/store/apps/details?id=com.chillpill&hl=en_US",
        github: "https://github.com/MrMicrowaveOven/chill-pill",
    },
]
